import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'calsoft-plan-compare-type11',
  templateUrl: './plan-compare-type11.component.html',
  styleUrls: ['./plan-compare-type11.component.scss']
})
export class PlanCompareType11Component implements OnInit{
  isChecked: boolean = false;
  pricedetail: any;

  @Input() item: any;
  @Input() data: any;

  constructor( private commonService: CommonService,) {

  }
  
  ngOnInit() {   
    this.pricedetail = JSON.parse(this.item.customField30);
  }      

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }

}
